// extracted by mini-css-extract-plugin
module.exports = {"ta-box":"Box_ta-box__1NVni","half-padding":"Box_half-padding__3CG5z","no-offset":"Box_no-offset__3L3wY"};